import { Component, OnInit, Input } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { APIService } from 'src/app/API.service';
import { Router } from '@angular/router';
import { EditBonusPage } from '../../../edit-bonus/edit-bonus.page';
import { SessionService } from '../../../services/session.service';
import { DataStore } from '@aws-amplify/datastore';
import { Bonus } from '../../../../models';

@Component({
  selector: 'app-bonuses-list',
  templateUrl: './bonuses.component.html',
  styleUrls: ['./bonuses.component.scss'],
})
export class BonusesComponent implements OnInit {
  @Input() ownershipType: any = 'agent';

  bonusList: any;
  cssClass: string;

  constructor(
    public navController: NavController, 
    public apiService: APIService,
    public sessionService: SessionService,
    public router: Router,
    public modalController: ModalController,
  ) { }

  async ngOnInit() {
    // @todo filters

    this.refreshUserList();
  }

  private async refreshUserList() {
    const bonuses = await DataStore.query(Bonus);    
    this.bonusList = bonuses.filter(b =>
        //b.userBonusId == this.sessionService.user?.id
        b.user.id == this.sessionService.user?.id
    );
    // this.applyClassBySelection('rollIn');
  }

  openBonus(bonusId: string) {
    this.router.navigate(['/bonus', bonusId]);
  }

  editBonus(bonusId: string) {
    this.openEditBonustModal(bonusId);
  }
  private async openEditBonustModal(bonusId: any) {
    const modal = await this.modalController.create({
      component: EditBonusPage,
      componentProps: { bonusId : bonusId },
      cssClass: 'custom-modal',
    });
    await modal.present();
    await modal.onWillDismiss().then(data => {
      // this.refreshContractsList();
    })
  }

  async deleteBonus(bonusId: string) {
    if (confirm("Do you want to delete this Bonus")) {
      await DataStore.delete(Bonus, bonusId);
      // let the animation finish its job
      setTimeout(() => {
        // this.refreshContractsList();
      }, 1000);
    }
  }

}
